import React from 'react';
import { useStore } from '../../stores';
import { Modals } from '../../stores/layers';
import { useTranslateFunction } from '../../helpers/useTranslationHook';

import classNames from 'classnames'

export const ButtonFavorite = () => {

  const { t } = useTranslateFunction('infolayer')
  const { poi, config, favourites, layers } = useStore()
  const isCustomPoi = poi.active?.provider === 'custom_poi';

  const isFavourite = () => favourites.list.filter((fav) => fav.id === poi.active.id).length > 0;
    
  return (
  
    <>

     {config.features.favourites && !isCustomPoi ? (
        <button
          className={classNames(
            'w-full mr-3 border border-neutral-200 py-2 px-3 relative overflow-hidden cursor-pointer text-center text-neutral-600 text-sm rounded-xl transition-all hover:bg-brand-3 hover:text-white',
            {
              'active' : isFavourite()
            }
          )}
          onClick={() => { favourites[!isFavourite() ? 'add' : 'remove'](poi.active); }}
        >
          <span className="block text-lg icon icon-heart-empty"></span>
          {!isFavourite()
            ? t('add_to_favorites')
            : t('remove_from_favorites')
          }
        </button>
      ) : null
    }
    
    {isCustomPoi ? (
      <button
        className="w-full mr-3 border border-neutral-200 py-2 px-3 relative overflow-hidden cursor-pointer text-center text-neutral-600 text-sm rounded-xl transition-all hover:bg-brand-3 hover:text-white"
        onClick={() => {
          layers.openModal(Modals.confirmLocationsDelete);
        }}
      >
        <span className="block text-lg icon icon-close"></span>
        {t('favourites:button_delete')}
      </button>
    ) : null}
      
    </>
  );
  
};